import React from 'react';
import DynamicCrudPage from '../../../components/DynamicCrudPage';
import { useBonusTargets, useCompanies, useTeams, useUsers } from '../../../hooks';
import { SCREENS } from '../../../constants/permissions';
import AddIcon from '@mui/icons-material/Add';

// team_id ve user_id arasında XOR ilişkisi var (DB CHECK constraint).
// İkisi de boş seçilirse "şirket geneli" hedef olur.
const buildFormFields = (fields, additionalData, isRootUser) => {
  const teamList = additionalData?.teams?.teams || [];
  const userList = additionalData?.users?.users || [];
  const companyList = additionalData?.companies?.companies || [];

  return fields
    .map((f) => {
      if (f.name === 'companyId') {
        return {
          ...f,
          options: companyList.map((c) => ({ value: c.id, label: c.name })),
          showIf: () => isRootUser,
        };
      }
      if (f.name === 'team_id') {
        return {
          ...f,
          options: [
            { value: '', label: '— (Yok)' },
            ...teamList.map((t) => ({ value: t.id, label: t.name })),
          ],
          // user_id seçildiyse team_id'yi gizle — DB CHECK XOR'u UI'da enforce.
          showIf: (formData) => !formData.user_id,
        };
      }
      if (f.name === 'user_id') {
        // Aynı isimli kullanıcılar duplicate React key uyarısı vermesin
        // diye id ile dedupe + label sonuna #id.
        const seen = new Set();
        return {
          ...f,
          options: [
            { value: '', label: '— (Yok)' },
            ...userList
              .filter((u) => (seen.has(u.id) ? false : seen.add(u.id)))
              .map((u) => ({
                value: u.id,
                label: `${(`${u.firstName || ''} ${u.lastName || ''}`).trim() || 'Kullanıcı'} #${u.id}`,
              })),
          ],
          // team_id seçildiyse user_id'yi gizle.
          showIf: (formData) => !formData.team_id,
        };
      }
      return f;
    })
    .filter((f) => (f.name === 'companyId' ? isRootUser : true));
};

const BonusTargetsPage = () => (
  <DynamicCrudPage
    entityType="bonusTargets"
    screen={SCREENS.PRIM_MANAGEMENT}
    hook={useBonusTargets}
    additionalHooks={{ companies: useCompanies, teams: useTeams, users: useUsers }}
    addButtonTextKey="bonusTargets.actions.add"
    addButtonIcon={<AddIcon />}
    entityTypeForDataTable="bonusTargets"
    customFormFields={buildFormFields}
  />
);

export default BonusTargetsPage;
